import React, { useCallback, useState } from 'react';
import { Box, Content, FormButton } from './styles';
import Button from '../../button';
import UserPreferenceSingleton from '../../../helpers/userPreferenceSingleton';
import { createNewMilestone, getMilestoneList, updateMilestone } from '../../../services/projectServices';
import { isEmpty } from '../../../helpers/common';
import { captureException } from '../../../services/logService';
import { dispatchTaskError } from '../../../services/taskServices';
import { Milestone } from '../../../mobx/interfaces/project';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';
import Input from '../../input';

interface Props {
  onClose: () => void;
  projectId: string;
  milestone?: Milestone | null;
}

const MilestoneModal: React.FC<Props> = (props) => {
  const { onClose, projectId, milestone } = props;
  //States
  const [loading, setLoading] = useState(false);
  const [milestoneName, setMilestoneName] = useState<string>(milestone?.milestoneName || '');

  const onChangeMilestoneName = useCallback((value: string) => {
    setMilestoneName(value);
  }, []);

  const onSubmit = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        setLoading(true);
        if (isEmpty(milestoneName)) {
          dispatchTaskError('Please enter milestone name.');
          return;
        }
        let result;
        if (!isEmpty(milestone?.id)) {
          const payload = {
            milestoneId: milestone?.id,
            milestoneName: milestoneName
          };
          result = await updateMilestone(payload);
        } else {
          const currentUser = UserPreferenceSingleton.getInstance().getCurrentUser();
          const payload = {
            userId: currentUser?.id,
            projectId,
            milestoneName: milestoneName
          };
          result = await createNewMilestone(payload);
        }
        if (result) {
          onClose();
          await getMilestoneList(projectId, false, true);
        }
      } catch (error) {
        captureException(error);
        setLoading(false);
      } finally {
        setMilestoneName('');
        setLoading(false);
      }
    },
    [milestone?.id, milestoneName, onClose, projectId]
  );

  return (
    <Box onSubmit={onSubmit}>
      <ModalHeader title={!isEmpty(milestone?.id) ? 'Edit Milestone' : 'Create New Milestone'} onClose={onClose} />
      <Content>
        <Input
          label='Milestone Name'
          placeHolder='Enter milestone name'
          value={milestoneName}
          onChange={(e) => onChangeMilestoneName(e.target.value)}
        />
        <FormButton>
          <Button title='Cancel' variant={BUTTON_TYPE.SECONDARY} buttonType='button' onClick={onClose} />
          <Button
            title={!isEmpty(milestone?.id) ? 'Edit Milestone' : 'Create Milestone'}
            variant={BUTTON_TYPE.PRIMARY}
            buttonType='submit'
            isLoading={loading}
            disabled={loading}
          />
        </FormButton>
      </Content>
    </Box>
  );
};

export default MilestoneModal;
